import type { Brand } from '@fuze/tokens';

import onwardLogo from './onward-logo.svg';

/** The Nexus brand theme this program renders in. */
export const brand: Brand = 'ucbOnward';

export const programLogo = { src: onwardLogo, alt: 'ONWARD' } as const;
